/**
 * useSimulatorAchievements — react-query wrapper around GET /simulator/achievements.
 *
 * Returns the user's unlocked achievements (one per eneatype × difficulty).
 * The hard-difficulty 9-of-9 is what unlocks "zerou" leaderboard status.
 */
import { useQuery } from "@tanstack/react-query";
import { useSession } from "@clerk/clerk-react";
import { getAchievements } from "../api/client";
import type { AchievementsResponse } from "../types";

export function useSimulatorAchievements() {
  const { session } = useSession();
  return useQuery<AchievementsResponse>({
    queryKey: ["simulator", "achievements"],
    queryFn: async () => {
      const token = await session?.getToken();
      if (!token) throw new Error("Usuário não autenticado.");
      return await getAchievements(token);
    },
    enabled: Boolean(session),
    staleTime: 60_000,
  });
}
